import React from 'react';
import PortalInfo from './PortalInfo';

function Home() {
    return (
        <div className="card">
            <h5 className="card-header">Portal Info</h5>
            <div className="card-body home home-info">
                <PortalInfo/>
            </div>
        </div>
    );
}

export default Home;